import { __rest, __assign } from '../../_virtual/_tslib.js';
import React from 'react';
import classnames from 'classnames';
import Image from '../Image/index.js';
import styles from './styles.css.js';

var BackgroundImage = function BackgroundImage(_a) {
  var children = _a.children,
      contentClassName = _a.contentClassName,
      containerClassName = _a.containerClassName,
      imageClassName = _a.imageClassName,
      backgroundPosition = _a.backgroundPosition,
      htmlAttributes = _a.htmlAttributes,
      src = _a.src,
      imgixParams = _a.imgixParams,
      dataTestId = _a.dataTestId,
      rest = __rest(_a, ["children", "contentClassName", "containerClassName", "imageClassName", "backgroundPosition", "htmlAttributes", "src", "imgixParams", "dataTestId"]);

  if (backgroundPosition) {
    var style = {
      objectPosition: backgroundPosition
    };
    htmlAttributes = htmlAttributes || {};
    htmlAttributes.style = Object.assign(htmlAttributes.style || {}, style);
  }

  return React.createElement("div", {
    className: classnames(styles.container, containerClassName),
    "data-testid": dataTestId
  }, React.createElement(Image, __assign({
    src: src,
    className: classnames(imageClassName, styles.image),
    htmlAttributes: htmlAttributes,
    imgixParams: imgixParams
  }, rest)), children && React.createElement("div", {
    className: classnames(styles.content, contentClassName)
  }, children));
};

export default BackgroundImage;
//# sourceMappingURL=index.js.map
